export const ROUTES = {
  DASHBOARD_PM: '/dashboard/pm',
  TIMESHEET: '/timesheet',
  CALENDAR: '/calendar',
  CALENDAR_MONTH: '/calendar/month/:year/:month',
  MY_SUBMITS: '/submits',
  MY_PROJECTS: '/my-projects',
  APPROVALS: '/approvals',
  TIME_OFF: '/time-off',
  ANALYTICS: '/analytics',
  PROFILE: '/profile',
  REPORTS: {
    HUB: '/reports',
    SUMMARY: '/reports/summary',
    TIME_AUDIT: '/reports/time-audit',
  },
  SETTINGS: {
    PROJECTS: '/settings/projects',
    ACTIVITIES: '/settings/activities',
    RESOURCES: '/settings/resources',
    PERMISSIONS: '/settings/permissions',
    WORKING_HOURS: '/settings/working-hours',
    DELEGATIONS: '/settings/delegations',
  },
} as const;
